const admin = angular.module('admin', ['core', 
    'auth', 
    'usuario', 
    'dashboard',
    'avisos',
    'vendas',
    'usuarios',
    'produtos',
    'areaMembros',
    'faq'
]);

admin.config(['coreFbProvider', (coreFbProvider) => {
    coreFbProvider.firebaseConfig(APP_CONSTANTS.FIREBASE_CONFIG);
}])

admin.config(['$stateProvider', '$urlServiceProvider', function($stateProvider, $urlServiceProvider) {

    const routes = [
        {
            name: 'admin',
            url: '',
            redirectTo: 'admin.dashboard',
            component: 'layoutComponent',
            data: { requiresAuth: true }
        },
        {
            name: 'admin.erro',
            url: '/erro',
            templateUrl: 'components/error/error.html',
            controller: ['$scope','coreLanguage', function($scope, $text){ $scope.$text = $text; }]
        },
        {
            name: 'admin.erroPermissao',
            url: '/erroPermissao',
            templateUrl: 'components/error/permissao.html',
            controller: ['$scope','coreLanguage', function($scope, $text){ $scope.$text = $text; }]
        },
        {
            name: 'erroPermissao',
            redirectTo: 'admin.erroPermissao',
        }
    ];

    routes.forEach($stateProvider.state);

    $urlServiceProvider.rules.otherwise({ state: 'admin.erro', options: { location: false } });
}]);